module.exports = __webpack_public_path__ + "img/Register-icon.e9a7daa6.svg";